import "url-search-params-polyfill";
import "whatwg-fetch";
import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import InputActionDemo from "./InputActionDemo";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

if (process.env.REACT_APP_MODE !== "dev") {
  const noop = () => {};
  console.log = noop;
}

ReactDOM.render(
  <Router>
    <Switch>
      <Route exact path="/input-action-demo" component={InputActionDemo} />
      <Route path="/" component={App} />
    </Switch>
  </Router>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
